import { Grid } from "@material-ui/core";

import useFornecedoresBodyController from "../../controllers/FornecedoresBodyController";
import SwitchesContainer from "../../commons/SwitchesContainer";
import { TabHeader } from "../../commons/TabHeader";

const TabGuias = () => {
  const { switches } = useFornecedoresBodyController();

  return (
    <>
      <TabHeader
        title="Visualização das guias no Cadastro de Fornecedores"
        subtitle="Defina quais guias serão exibidas no cadastro de fornecedores."
      />
      <Grid container direction="column">
        {switches.map(({ ...props }) => (
          <SwitchesContainer {...props} />
        ))}
      </Grid>
    </>
  );
};

export default TabGuias;
